<template>
  <v-container grid-list-xs class="pa-0 ma-0" fluid>
    <v-row class="pa-0 ma-0 white titlesdark--text" >
      <v-col md="8" sm="12" class="pa-0 ma-0">
        <span class="title titlesdark--text font-weight-bold pl-1">Correos</span>
      </v-col>
    </v-row>
    <v-row class="pa-0 ma-0">
      <v-col md="12" sm="12" class="pa-0 ma-0">
        <grid
          :tabla="'Caso_Correos'"
          :bActiveFilter="true"
          :bActiveExport="true"
          :bSingleSelect="true"
          :bShowSelect="false"
          :sIdTable="'idCaso_Correos'"
          :oTablesDependens="oTables"
          :bShowMapDetails="false"
          @idSelect="getIdSelect"
          @nameField="getNameFieldSelect">
        </grid>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import grid from '@/components/Grid/Grid.vue'
export default {
  name:"Correos",
  components: {
    grid,
  },
  data() {
    return {
      idSelect  : '',                 // Id seleccionado
      nameField : '',                 // Nombre del campo foreignKey
      oTables: {
        "Primary": "Departamentos",
        "Second": '',
        "Third": '',
        "Aux": ''
      }
    }
  },// fin data
  methods: {
    getIdSelect(sIdSelected) {
      this.idSelect = sIdSelected;
    },
    getNameFieldSelect(sNameFiled) {
      this.nameField = sNameFiled;
    }
  },
}
</script>